var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSoccerBall = function SvgSoccerBall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5 4 9l4 3 4-3-2-4H6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10 1c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm-7 9c0-3.9 3.1-7 7-7 2.8 0 5.2 1.6 6.3 3.9L14 10l2.3 3.1c-.8 1.6-2.2 2.9-3.9 3.5L9 14l-2.6 2C4.3 14.8 3 12.5 3 10z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgSoccerBall;